const data = [
	{
		Reviewer: `Worked as reviewer for IEEE conference, TEMSMET, 2021`,
	},
	{
		Reviewer: `Worked as reviewer for International conference, ICEI 2022
		`,
	},
	{
		Reviewer: `Worked as reviewer for International journal of communication system, SCI Journal`,
	},
	{
		Reviewer: `Worked as reviewer for IEEE world conference 2022`,
	},
	{
		Reviewer: `Worked as a reviewer in c-pgcon 2021 organized by SKNCOE, Pune`,
	},
	{
		Reviewer: `Worked as a reviewer in c-pgcon 2020 held at Amrut wahini college, Sangamner`,
	},
	{
		Reviewer: `Worked as a reviewer in c-Pgcon 2017 held at Sandip Foundation Nashik.`,
	},
	{
		Reviewer: `Worked as a reviewer in International Conference on Internet of Thing and Next 
		Generation Cloud Computing (ICINC) 2016 & 2017.`,
	},
	{
		Reviewer: `Worked as a session chair at international conference ICINC-2017.`,
	},
];

export default data;
